import React, { useState, useEffect } from 'react';
import '../../css/spendInsurance.css';
import { useMobileMediaQuery, useTabletMediaQuery } from '../../utils';
import CustomButton from '../CustomButton';

function EmptyInsuranceList() {

    const isMobile = useMobileMediaQuery();
    const isTablet = useTabletMediaQuery();  

    const hadleBtnClickNav = () => {
        window.open('https://minhamedis-saude360.medis.pt/UmbrellaApplication_FE/AssociarSeguros', '_blank');
    };

    return (
        <>
            <div className={ isTablet ? 'mainViewEmptyInsuranceList' : ( isMobile ? 'mainViewEmptyInsuranceListTablet' : 'mainViewEmptyInsuranceListMobile' )}>
                <div className='secondSliderAdsContainerDeductionsInfoSliderMobile'>
                    <div className='txtDescBoldViewDeductions'>Pode receber o saldo que tem na Carteira Virtual na sua conta bancária.</div>
                    <div className='txtDescViewDeductions'>Esta opção só é válida para contas Minha Médis com seguro Médis individual &#x28;saúde ou dentário&#x29; associado.</div>
                </div>
                <div className='faqBtnDeductionsInfo'>
                    <CustomButton 
                        text={isTablet ? 'Associar seguro à conta Minha Médis' : 'Associar seguro à conta'} 
                        textColor={'#00214D'}
                        onPress={hadleBtnClickNav} 
                        color={'#15D4B6'}
                        hasArrow
                        iconColor={'#00214D'}
                    />
                </div>
                <div className='mainSecondViewEmptyInsuranceList'>
                    <div className='txtDescViewDeductions'>
                        <span className='txtDescViewDeductions'>Se fizer o pagamento do seu seguro Médis de forma trimestral, semestral ou anual, esta</span>
                        <span className='txtDescBoldViewDeductions'> opção só fica disponível 45 dias antes da próxima data de pagamento do seguro.</span>
                    </div>
                </div>
            </div>
        </>
    )
}

export default EmptyInsuranceList